/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Part_5_DInputs */

const en_tut_part_5_d = /** @type {(inputs: Tut_Part_5_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents you assign like people, behind guardrails the server enforces.`)
};

const id_tut_part_5_d = /** @type {(inputs: Tut_Part_5_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen yang bisa ditugaskan seperti orang, dengan pagar yang ditegakkan server.`)
};

/**
* | output |
* | --- |
* | "Agents you assign like people, behind guardrails the server enforces." |
*
* @param {Tut_Part_5_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_part_5_d = /** @type {((inputs?: Tut_Part_5_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Part_5_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_part_5_d(inputs)
	return en_tut_part_5_d(inputs)
});